import React, { useState } from "react";

import { ic_buy, ic_sell } from "styles/img";

import { Message } from "constants/index";
import { numberWithCommas, cengoldAlert } from "../../lib/utils";
import { CengoldModal } from "../../components/CengoldModal";

const MyMoneyListItem = ({
  name,
  currentPrice,
  balance,
  diffPrice,
  handleClickBuyMove,
}) => {
  const className = name === "e금" ? "gold" : "silver";
  const totalPrices = (+balance * +currentPrice).toFixed(0);
  const diffPrices = (+balance * diffPrice).toFixed(0);

  let opText = "";
  let opClasName = "now";
  if (diffPrices > 0) {
    opText = "▲";
    opClasName = "plus";
  } else if (diffPrices < 0) {
    opText = "▼";
    opClasName = "minus";
  }
  const [showSellModal, setShowSellModal] = useState(false);
  const onCloseModal = () => {
    setShowSellModal(false);
  };

  return (
    <li className={className}>
      <div className="e_box">
        <div className="title">
          <div className="kind">{name}</div>
          <div className="right">
            <span className="tt1">현 시세</span>
            <span className="yellow">
              <span className="tt2">{numberWithCommas(currentPrice)}</span>
              <span className="tt3"> KRW/g</span>
            </span>
          </div>
        </div>
        <div className="number">
          <div className="tt1">
            {numberWithCommas(balance)}
            <span className="g"> g</span>
          </div>
          <div className="tt2">
            <ul>
              <li>
                <span className="left">평가금액</span>
                <span className="right">
                  <em className="now">{numberWithCommas(totalPrices)} KRW</em>{" "}
                </span>
              </li>
              <li>
                <span className="left">평가수익</span>
                <span className="right">
                  <em className={opClasName}>
                    {opText} {numberWithCommas(diffPrices)} KRW
                  </em>{" "}
                </span>
              </li>
            </ul>
          </div>
        </div>
        <div className="btn_area">
          <ul>
            <li>
              <span className="buy" onClick={handleClickBuyMove}>
                <img src={ic_buy} alt="매수" /> 매수
              </span>
            </li>
            <li className="apply_btn">
              <span
                className="sell pop"
                onClick={() => {
                  setShowSellModal(true);
                }}
              >
                <img src={ic_sell} alt="매도" />
                매도
              </span>
            </li>
          </ul>
        </div>
      </div>
      <CengoldModal
        visible={showSellModal}
        title={"매도하기 안내"}
        onClose={onCloseModal}
      >
        <div>매수하신 'e금', 'e은'의</div>
        <div>매도는 비단 앱에서 가능합니다.</div>
        <div>매도 대금의 인출은 비단 앱에서</div>
        <div>실명계좌 등록 후 가능합니다.</div>
      </CengoldModal>
    </li>
  );
};

export default MyMoneyListItem;
